// removed by extract-text-webpack-plugin
module.exports = {"container":"_2qVZ3kaWLdx5TBFSwXPJwH"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/FillNameFields/Fields/Save/styles.css
// module id = 2945
// module chunks = 0